import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 17h4v4h-4z","key":"svg-0"}],["path",{"d":"M10 17h4v4h-4z","key":"svg-1"}],["path",{"d":"M17 17h4v4h-4z","key":"svg-2"}],["path",{"d":"M17 10h4v4h-4z","key":"svg-3"}],["path",{"d":"M17 3h4v4h-4z","key":"svg-4"}],["path",{"d":"M10 10h4v4h-4z","key":"svg-5"}],["path",{"d":"M10 3h4v4h-4z","key":"svg-6"}],["path",{"d":"M3 3h4v4h-4z","key":"svg-7"}]]

const IconBrandPnpm = createReactComponent('outline', 'brand-pnpm', 'BrandPnpm', __iconNode);

export default IconBrandPnpm;